import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';


import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

//Lista de mecanismos del informe
// const DetallePl = ({elemento, handleClickidLista}) => {
const DetallePl = ({elemento, handleClickidLista}) => {
  let urlSlcm = 'https://montserratslcm.com/api/imgorden/'
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
    {/* <tr className=''> */}
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrHallazgo?elemento.descrHallazgo:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoOrden}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProg?elemento.fechaProg.substr(0, 10):""}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaReal?elemento.fechaReal.substr(0, 10):""}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadReal}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minutosReal}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioReal}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.imgAntes &&
           <img src={urlSlcm + elemento.imgAntes} height = {70} width = {100} alt="Imagen"/>
        }
        {!elemento.imgAntes &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.imgDespues &&
           <img src={urlSlcm + elemento.imgDespues} height = {70} width = {100} alt="Imagen"/>
          }
        {!elemento.imgDespues &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ObservacionesReal}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};



class ProgBuscProg2 extends React.Component {
  state={argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin}, argsBuscInf: {}, idListaP: [], inicio: 'S',
  argsQuery: `{$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
    descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, 
    descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, usuarioCreate: 1, nombreUsuarioReal: 1, 
    imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1}},   
    {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
      {$unwind: '$usuario'},
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
      descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, 
      descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, nombreUsuarioReal: 1, 
      imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1, usuarioCreate: '$usuario.nombreUsuario'}}` 
}

handleChange = async (ev, indice) => {

  if(ev.target.name==="desde"||ev.target.name==="hasta"){
    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value
    let argsBuscar=''
    if(ev.target.name==="desde"){
      argsBuscar += `fechaProg: { $gte: new Date('${ev.target.value}'), $lte: new Date('${argsDocum.hasta}') }`
    }else{
      argsBuscar += `fechaProg: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${ev.target.value}') }`
    }
    if(this.props.argsBuscProg.descrEmpresa){
      argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscProg.descrEmpresa}/i`
    }          
    if(this.props.argsBuscProg.descrPlanta){
      argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
    }
    if(this.props.argsBuscProg.descrSeccion){
      argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
    }
    if(this.props.argsBuscProg.descrEquipo){
      argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
    }
    if(this.props.argsBuscProg.descrComponente){
      argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
    }
    if(this.props.argsBuscProg.descrMecanismo){
      argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
    }
    if(this.props.argsBuscProg.ruta){
      argsBuscar += `, 'ruta': ${this.props.argsBuscProg.ruta}`
    }
    if(this.props.argsBuscProg.numeroOrden){
      argsBuscar += `, 'numeroOrden': ${this.props.argsBuscProg.numeroOrden}`
    }
    if(this.props.argsBuscProg.descrMetodo){
      argsBuscar += `, 'descrMetodo': /${this.props.argsBuscProg.descrMetodo}/i`
    }
    if(this.props.argsBuscProg.estadoOrden){
      argsBuscar += `, 'estadoOrden': /${this.props.argsBuscProg.estadoOrden}/i`
    }
    if(this.props.argsBuscProg.realizado){
      argsBuscar += `, 'realizado': /${this.props.argsBuscProg.realizado}/i`
    }
    // let argsBuscarF=""
      let argsBuscProg = ""
      if(this.props.argsBuscProg.numDocum){
        argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$sort: {numeroOrden: -1}}, {$limit: ${this.props.argsBuscProg.numDocum}}]`}
      }else{
        argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$sort: {numeroOrden: -1}}, {$limit: 100}]`}
      }
console.log(argsBuscProg)
      this.props.allOrdenRtes.refetch(argsBuscProg)

      this.setState({argsBuscProg: this.props.argsBuscProg})
  }
}


  componentDidUpdate(prevProps){
    if(this.props.argsBuscProg!==this.state.argsBuscProg || this.state.inicio==='S'){
      const argsDocum = this.state.argsDocum
      // let argsBuscar = `'estadoOrden': 'Cerrado'`
      let argsBuscar = `'descrEmpresa': {$ne: 'XXX'}`

      if(this.props.argsBuscProg.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscProg.descrEmpresa}/i`
      }          
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }
      if(this.props.argsBuscProg.ruta){
        argsBuscar += `, 'ruta': ${this.props.argsBuscProg.ruta}`
      }
      if(this.props.argsBuscProg.numeroOrden){
        argsBuscar += `, 'numeroOrden': ${this.props.argsBuscProg.numeroOrden}`
      }
      if(this.props.argsBuscProg.descrMetodo){
        argsBuscar += `, 'descrMetodo': /${this.props.argsBuscProg.descrMetodo}/i`
      }
      if(this.props.argsBuscProg.estadoOrden){
        argsBuscar += `, 'estadoOrden': /${this.props.argsBuscProg.estadoOrden}/i`
      }
      if(this.props.argsBuscProg.realizado){
        argsBuscar += `, 'realizado': /${this.props.argsBuscProg.realizado}/i`
      }
      argsBuscar += `, fechaProg: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
      let argsBuscProg = ""
      if(this.props.argsBuscProg.numDocum){
        argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$sort: {numeroOrden: -1}}, {$limit: ${this.props.argsBuscProg.numDocum}}]`}
      }else{
        argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$sort: {numeroOrden: -1}}, {$limit: 100}]`}
      }
      console.log(argsBuscProg)
      this.props.allOrdenRtes.refetch(argsBuscProg)

      this.setState({argsBuscProg: this.props.argsBuscProg, inicio: 'N'})
    }
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

    this.setState({idListaP: idListaP})
  }

  handleCopiaInfPdf = async (ev, lista)=>{
    console.log(lista)
    if(lista.length>0){
      let dirSlcm = 'images/logos/LCMSAS.png'
      
      let doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)

      for (var i = 0; i < lista.length; i++) {
        console.log(lista[i])
        document.body.style.cursor = 'wait'
        let logo = ""
        if(this.props.allEmpresaRtes.allEmpresaRtes){
  
          let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${lista[i].descrEmpresa}'}}]`}
          let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
          logo = await data.allEmpresaRtes[0].logo
        }
        let dirEmpresa = 'images/logos/' + logo
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        

        //MECANISMOS POR EQUIPO
            doc.setFillColor('#E9E4F0');
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
            doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'F', true)
            doc.setFillColor('#bdc3c7');

            doc.setDrawColor('black');
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
            doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'S', true)

            doc.setFontSize(8);
            doc.setFontStyle('bold');
            doc.text(`PLANTA: ${lista[i].descrPlanta}`,14, 40)
            doc.text(`SECCION: ${lista[i].descrSeccion}`, (widthDoc/2)+2, 40)
            doc.text(`OPERARIO: ${lista[i].nombreUsuario}  -  EQUIPO: ${lista[i].codEquipo} ${lista[i].descrEquipo}`, (widthDoc/2), 45, 'center')
            doc.text(`COMPONENTE: ${lista[i].descrComponente}`,14, 50)
            doc.text(`MECANISMO: ${lista[i].descrMecanismo}`, (widthDoc/2)+2, 50)
            let tablaRte = []
            let argsUpd = []
              
            argsUpd.push(lista[i].fechaProg?lista[i].fechaProg.substr(0, 10):"")
            argsUpd.push(lista[i].estadoOrden==='Cerrado'?lista[i].fechaReal?lista[i].fechaReal.substr(0, 10):"":"")
            argsUpd.push(lista[i].horaReal?lista[i].horaReal + ":00":"")
            argsUpd.push(lista[i].minutosReal)
            argsUpd.push(lista[i].puntosLub)
            argsUpd.push(lista[i].descrMetodo)
            argsUpd.push(lista[i].descrTarea)
            argsUpd.push(lista[i].descrHallazgo?lista[i].descrHallazgo:'')
            argsUpd.push(lista[i].estadoOrden)
            argsUpd.push(lista[i].descrLubricante)
            argsUpd.push(lista[i].cantidadReal)
            argsUpd.push(lista[i].abrevUnidad)
            tablaRte.push(argsUpd) 

            let indice = 0
            let esComp = false
            doc.autoTable({
              startY: 52,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 6,
                lineColor: "black",
                lineWidth: 0.1,
                valign: "top",
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                valign: "top",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 6
              },
              bodyStyles: {
                // fillColor: "#E9E4F0",
                fillColor: "white",
                textColor: "black",
                halign: "center",
                minCellHeight: 3
              },
              columnStyles: {
                0: {cellWidth: 18},
                1: {cellWidth: 18},
                2: {cellWidth: 16},
                3: {cellWidth: 20},
                4: {cellWidth: 12},
                5: {cellWidth: 24},
                6: {cellWidth: 34},
                7: {cellWidth: 30},
                8: {cellWidth: 11},
                9: {cellWidth: 45.7},
                10: {cellWidth: 15},
                11: {cellWidth: 8},
              },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='body'){
                  // if(data.column.index === 0){
                  //   esComp = false
                  //   if(data.cell.text[0].substr(0, 9)==='OPERARIO:'){
                  //     esComp = true
                  //   }
                  // }

                  data.cell.styles.minCellHeight = 3
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                  // if(esComp){
                  //   if(data.column.index===0){
                  //     data.cell.colSpan = 15
                  //     data.cell.styles.halign = "center"
                  //     data.cell.styles.fontStyle = "bold"
                  //   }
                  //   data.cell.styles.minCellHeight = 3
                  //   data.cell.styles.fillColor = "#E9E4F0"
                  // }
                }
              },

              didDrawCell: (data) => {
                //imagenes en autoTable
                //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
  if(data.row.index===-1){
  console.log("ojoooo")
  }

                // if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                //   esComp = false
                //   if(data.row.index===0){
                //     indice = 0
                //   }else{
                //     if(data.cell.text[0].substr(0, 9)!=='OPERARIO:'){
                //       indice += 1
                //     }else{
                //       esComp = true
                //     }
                //   }
                // }
              },
              alternateRowStyles: {
                // fillColor: "white",
                textColor: "black"
              },
              // head: [["MECANISMO", "COD. MECANISMO", "CANTIDAD", "LUBRICACION", "", "", "", "", "LUBRICANTE", "", "", "", "Firmas"],
              //         ["", "", "", "PUNTOS", "FRECUENCIA", "METODO", "TAREA", "PROCEDIMIENTO", "CLASE", "GRADO", "TIPO", "CATEGORIA", ""]],
              head: [["Fecha reporte", "Fecha ejec", "Hora ejec.", "Minutos operario", "Puntos", "Método", "Tarea", "tipo de hallazgo", "Estado", "Lubricante", "Cant real", "Und"]],
              body: tablaRte,
              margin: {top: 40, left: 12, right: 12, bottom: 25}
            })

            doc.text('Imagen antes', 64, 70, 'left')
            doc.text('Imagen después', (widthDoc/2)+56, 70, 'center')

            let urlImagenOrden = 'https://montserratslcm.com/api/imgorden/'
            let imgSource = new Image();

            if(lista[i].imgAntes){
              let nuevoAncho = 0, nuevoAncho1 = 0, nuevoAlto = 0, nuevoAlto1 = 0, porcEscalado = 0
              let dirImgAntes = urlImagenOrden + lista[i].imgAntes
              imgSource.src = dirImgAntes;
              document.images[1].src=imgSource.src;
              nuevoAncho1=imgSource.width;
              nuevoAlto1=imgSource.height
              document.images[1].src=""
              try{
                imgSource.src = dirImgAntes;
                doc.convertStringToImageData(imgSource)

                let ancho = 100
                let alto = 67
                if(nuevoAncho1>nuevoAlto1){
                  nuevoAncho = ancho
                  porcEscalado = (nuevoAncho1 * 100) / ancho
                  nuevoAlto = (100 * nuevoAlto1) / porcEscalado
                  if(parseInt(nuevoAlto, 10)>67){
                    porcEscalado = (parseInt(nuevoAlto, 10) * 100) / 67
                    nuevoAncho = (100 * 200) / porcEscalado
                    nuevoAlto = 67
                  }
                }else{
                  nuevoAlto = alto
                  porcEscalado = (nuevoAlto1 * 100) / alto
                  nuevoAncho = (100 * nuevoAncho1) / porcEscalado
                  if(parseInt(nuevoAncho, 10)>100){
                    porcEscalado = (parseInt(nuevoAncho, 10) * 100) / 100
                    nuevoAlto = (100 * 67) / porcEscalado
                    nuevoAncho = 100
                  }
                }
                nuevoAncho = parseInt(nuevoAncho, 10)
                nuevoAlto = parseInt(nuevoAlto, 10)

                doc.addImage(imgSource, 'PNG', 12+((120-nuevoAncho)/2), 72, nuevoAncho, nuevoAlto);
              }catch{
                console.log("Imagen no existe")
              }

              doc.setTextColor('#3366BB');
              doc.textWithLink('Ver imagen original', 58, 145, {url: dirImgAntes})
              doc.setTextColor('black');
            }
            if(lista[i].imgDespues){
              let dirImgDespues = urlImagenOrden + lista[i].imgDespues
              let nuevoAncho = 0, nuevoAncho1 = 0, nuevoAlto = 0, nuevoAlto1 = 0, porcEscalado = 0
              imgSource.src = dirImgDespues;
              document.images[1].src=imgSource.src;
              nuevoAncho1=imgSource.width;
              nuevoAlto1=imgSource.height
              document.images[1].src=""
              try{
                imgSource.src = dirImgDespues;
                doc.convertStringToImageData(imgSource)

                let ancho = 100
                let alto = 67
                if(nuevoAncho1>nuevoAlto1){
                  nuevoAncho = ancho
                  porcEscalado = (nuevoAncho1 * 100) / ancho
                  nuevoAlto = (100 * nuevoAlto1) / porcEscalado
                  if(parseInt(nuevoAlto, 10)>67){
                    porcEscalado = (parseInt(nuevoAlto, 10) * 100) / 67
                    nuevoAncho = (100 * 200) / porcEscalado
                    nuevoAlto = 67
                  }
                }else{
                  nuevoAlto = alto
                  porcEscalado = (nuevoAlto1 * 100) / alto
                  nuevoAncho = (100 * nuevoAncho1) / porcEscalado
                  if(parseInt(nuevoAncho, 10)>100){
                    porcEscalado = (parseInt(nuevoAncho, 10) * 100) / 100
                    nuevoAlto = (100 * 67) / porcEscalado
                    nuevoAncho = 100
                  }
                }
                nuevoAncho = parseInt(nuevoAncho, 10)
                nuevoAlto = parseInt(nuevoAlto, 10)

                doc.addImage(imgSource, 'PNG', (widthDoc/2)+((120-nuevoAncho)/2), 72, nuevoAncho, nuevoAlto);
              }catch{
                console.log("Imagen no existe")
              }

              doc.setTextColor('#3366BB');
              doc.textWithLink('Ver imagen original', (widthDoc/2)+48, 145, {url: dirImgDespues})
              doc.setTextColor('black');
            }
            
            doc.setFillColor('#E9E4F0');
            doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], 12,150, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], (widthDoc/2),150, [1,1], 'F', true)
            doc.setFillColor('#bdc3c7');


            doc.setDrawColor('black');
            doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], 12,150, [1,1], 'S', true)
            doc.text("INFORME INICIAL REPORTADO POR: " + lista[i].usuarioCreate, 13, 154, 'left')
            doc.lines([[(widthDoc/2)-20,0],[0,40],[0-(widthDoc/2)+20,0]], 12,155, [1,1], 'S', true)
            doc.text(lista[i].observaciones, 13, 159, {align: 'justify',lineHeightFactor: 1.5,maxWidth:116})

            doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], (widthDoc/2),150, [1,1], 'S', true)
            doc.text("INFORME DE EJECUCION REPORTADO POR: " + lista[i].nombreUsuarioReal, (widthDoc/2)+1, 154, 'left')
            doc.lines([[(widthDoc/2)-20,0],[0,40],[0-(widthDoc/2)+20,0]], (widthDoc/2),155, [1,1], 'S', true)
            doc.text(lista[i].observacionesReal, (widthDoc/2)+1, 159, {align: 'justify',lineHeightFactor: 1.5,maxWidth:116})



          const pageCount = doc.internal.getNumberOfPages();
          // For each page, print the page number and the total pages
          // for(var ii = 1; ii <= 2; ii++) {
                // Go to page i
              doc.setPage(i+1);

  //ENCABEZADO DE PAGINA
              doc.setFontSize(12);
              doc.setFontType("bold");
              doc.text(lista[i].descrEmpresa, widthDoc/2, 14, 'center')
              doc.text("ORDEN DE TRABAJO No. " + String(lista[i].numeroOrden), widthDoc/2, 20, 'center')
              doc.setFontSize(8);

              imgSource = new Image();
              try{
                imgSource.src = dirSlcm;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
              }catch{
                console.log("Logo de LCM no existe")
              }

              try{
                imgSource.src = dirEmpresa;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', widthDoc-55-12, 12, 55, 17);
              }catch{
                console.log("Logo de la empresa no existe")
              }
  //FIN ENCABEZADO DE PAGINA

              doc.text('Pag ' + String(i+1) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
              doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
              // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
          // }
          if(i<lista.length-1){
            doc.addPage()
          }
        }
      
      let nameDoc = `BITACORA DE ORDENES DE TRABAJO.pdf`
      doc.save(nameDoc)

      document.body.style.cursor = 'default'
    }else{

    }
    
    //FIN Exportar a Pdf
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }

  render(){
    const {idListaP, argsDocum} = this.state;
    let list = []
    let mensaje1 = "GENERAR BITACORA DE OTs EN PDF"
    // if(idListaP.numeroOrden){
    //   mensaje1 += idListaP.numeroOrden
    // }
    let urlSlcm = 'https://montserratslcm.com/api/imgorden/'

    if(this.props.allOrdenRtes.allOrdenRtes){list = this.props.allOrdenRtes.allOrdenRtes}
console.log(list)
    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1">
           <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '30%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '30%'}}>
                  <p style={{color: 'white', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Ejecutar
                  </p>
                  <Button id="pdf" name="pdf" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInfPdf(ev, list)} fluid>
                    {mensaje1}
                  </Button>
                </div>  
              </div>
            </div>
            <div>
              <div style={{height: '28em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Método</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de hallazgo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Realiz.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha prog.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Min.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Reporta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ejecuta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Img antes</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Img después</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones</th>
                    </tr>
                  </thead>
                  <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
                </table>
                <p></p>
              </div>
              <hr></hr>
              <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idListaP.imgAntes?urlSlcm + idListaP.descrEmpresa.replace(/\./g,'') + '/' + idListaP.imgAntes:""} width='70%'></img>
                  </div>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idListaP.imgDespues?urlSlcm + idListaP.descrEmpresa.replace(/\./g,'') + '/' + idListaP.imgDespues:""} width='70%'></img>
                  </div>
                </div>
              </div>
            </div>
            </div>
        </Form>           
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    // options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoOrden': 'Cerrado'}}, {$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),

)(ProgBuscProg2)
